import { createContext, useContext } from 'react';
import { useRealtimeShiftManager, RealtimeShiftManagerOptions } from '../lib/supabase/shifts/realtimeShiftManager';

interface RealtimeShiftContextType {
  isConnected: boolean;
}

const RealtimeShiftContext = createContext<RealtimeShiftContextType | undefined>(undefined);

interface SupabaseRealtimeProviderProps extends RealtimeShiftManagerOptions {
  children: React.ReactNode;
}

export function RealtimeShiftProvider({ children, ...options }: SupabaseRealtimeProviderProps) {
  const { isConnected } = useRealtimeShiftManager(options);

  return (
    <RealtimeShiftContext.Provider value={{ isConnected }}>
      {children}
    </RealtimeShiftContext.Provider>
  );
}

export function useSupabaseRealtime() {
  const context = useContext(RealtimeShiftContext);
  if (context === undefined) {
    throw new Error('useSupabaseRealtime must be used within a RealtimeShiftProvider');
  }
  return context;
}